<template>
  <div id="app">
    <div class="logo">
      <img src="./assets/logo.svg" style="height:75px;" />
    </div>
    <div id="nav" class="top" :class="route">
      <router-link to="/">Home</router-link>
      <router-link to="/center">Digital Displacement&reg; Centre of Excellence</router-link>
      <router-link to="/markets">APPLICATIONS</router-link>
      <router-link to="/demo">Demo</router-link>
    </div>
    <transition name="slide-fade" :duration="{ enter: 500, leave: 800 }" mode="out-in">
    <router-view class="top" />
    </transition>
    <div class="background">
      <img
        src="./assets/DDP-Schematics-01.svg"
        style="left: 30%;
    top: 54%;animation-delay:3s;"
      />
      <img src="./assets/DDP-Schematics-02.svg" style="top: 6%;left: -17%;" />
      <img src="./assets/DDP-Schematics-03.svg" style="left:65%;animation-delay:8s;" />
    </div>
  </div>
</template>
<script>
export default{
    computed: {
    route () {
      // We will see what `params` is shortly
      return this.$route.name;
    }
  },
}
</script>
<style lang="scss">
.top {
  z-index: 2;
  margin-top: 6em !important;
}
@font-face {
  font-family: Myriad Pro;
  src: url("../public/img/MyriadPro-Regular.otf") format("OpenType");
  font-weight: normal;
}
@font-face {
  font-family: Myriad Pro;
  src: url("../public/img/MyriadPro-Bold.otf") format("OpenType");
  font-weight: bold;
}
#app {
  font-family: "Myriad Pro", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #ed1c24;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    #ed1c24 0%,
    #c4161c 100%
  );
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    #ed1c24 0%,
    #c4161c 100%
  );
  background: radial-gradient(ellipse at center, #ed1c24 0%, #c4161c 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ed1c24', endColorstr='#c4161c',GradientType=1 );
  display: flex;
  justify-content: center;
  align-items: start;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  .logo {
    width: 100%;
    background-image: linear-gradient(90deg,#c5161c 0%,rgba(0,0,0,0) 50%);
    position: absolute;
    top: 0;
    z-index: 1;
  }
  .background {
    z-index: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    position: absolute;
    img {
      width: 800px;
      opacity: 0.4;
      position: absolute;
      z-index: -1;
      animation-name: grow;
      animation-duration: 16s;
      animation-iteration-count: infinite;
      will-change: transform;
    }
    @keyframes grow {
  0%{transform: scale(1);}
  50%{transform: scale(1.1);}
  100%{transform: scale(1);}
}
  }
}
#nav {
  position: absolute;
  padding-bottom: 3em;
  padding-top: 2em;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.9));
  transition: 30ms opacity ease-in-out;
  &.home{
    opacity: .65;
  }
  :not(.home){
    opacity: 1;
  }
  a {
    padding: 10px;
    border: 8px solid #b4b4b4;
    color: white;
    font-size: 1.75em;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: none;
    text-align: center;
        width: 350px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.router-link-exact-active{
  background: #c5161c;
  border: 8px solid white !important;
}
.slide-fade-enter-active {
  transition: all .4s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
